export default "__VITE_ASSET__C2iTS89R__"